import React from 'react'
import { ButtonMenu, Icon, MenuItem, Select, TextField, makeStyles } from '@cicero/ui'
import { useForm } from '@cicero/ui/forms'
import { PageSchema, useSetting } from '../models'
import { CardLayout, TableLayout } from './layouts'
import { PageFilters, QuickAddPageToTemplate } from 'forms'

/**
 * An interactive search for page results
 */
export const PageSearch = () => {
  const { searchWrapper, searchInput, nav, navGroup } = useStyles()
  const $search = useForm({
    onSubmit: () => {},
    initialValues: () => ({
      term: '',
      filters: [],
      filtersQuery: {},
    }),
  })
  const [view, setView] = useSetting('pagelist.view', 'card')
  const [isLoading, results] = PageSchema.HOOKS.usePageFilters($search.values.filters, $search.values.term)

  return (
    <div className={searchWrapper}>
      <nav className={nav}>
        <div className={navGroup}>
          <ButtonMenu label={`Filters (${$search.values.filters?.length || 0})`}>
            <PageFilters {...$search.props('filters')} />
          </ButtonMenu>
        </div>
        <TextField
          label="Search"
          variant="filled"
          className={searchInput}
          InputProps={{ endAdornment: <Icon>search</Icon> }}
          {...$search.props('term')}
        />
        <div className={navGroup}>
          <Select value={view} onChange={(e) => setView(e.target.value as string)}>
            <MenuItem value="card">Card View</MenuItem>
            <MenuItem value="table">Table View</MenuItem>
          </Select>
          <QuickAddPageToTemplate />
        </div>
      </nav>
      {(() => {
        switch(view) {
          case 'card': return <CardLayout pages={results} isLoading={isLoading} />
          case 'table': return <TableLayout pages={results} isLoading={isLoading} />
        }
      })()}
    </div>
  )
}

const useStyles = makeStyles({
  searchWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  searchInput: {
    minWidth: 500,
    // flexGrow: 1,
  },
  nav: {
    padding: 6,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  navGroup: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',

    '& > *': {
      margin: '0 6px',
    },
  },
})
